const EventBus = {
  subscriptions: {},

  on(event, listener) {
    this.subscriptions[event] = this.subscriptions[event] || [];
    this.subscriptions[event].push(listener);
    return {
      cancel: () => this.off(event, listener),
    };
  },

  off(event, listener) {
    this.subscriptions[event] = this.subscriptions[event] || [];
    this.subscriptions[event] = this.subscriptions[event].filter((subscriber) => subscriber !== listener);
  },

  dispatch(event, payload) {
    const callbacks = this.subscriptions[event] || [];
    callbacks.forEach((callback) => callback(payload));
  },
};

export default EventBus;
